import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/layout/Layout";
import Login from "./components/auth/LogIn";
import ForgotPassword from "./components/auth/ForgotPassword";
import Home from "./pages/Home";
import Coriander from "./pages/Coriander";
import Turmeric from "./pages/Turmeric";
import Packaging from "./pages/Packaging";
import RTC from "./pages/RTC";
import UserManagement from "./pages/UserManagement";

function App() {
  // Initialize authentication state as false until verified
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is logged in on component mount
  useEffect(() => {
    const checkUserAuth = () => {
      // Check for token in localStorage
      const token = localStorage.getItem("user");
      const userRole = localStorage.getItem("userRole");

      if (token) {
        // Here you could also validate the token if needed
        setIsAuthenticated(true);
        setIsAdmin(userRole === "admin");
      } else {
        setIsAuthenticated(false);
        setIsAdmin(false);
      }
      setIsLoading(false); // Authentication check complete
    };

    checkUserAuth();
  }, []);

  // Handle successful login
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    const userRole = localStorage.getItem("userRole");
    setIsAdmin(userRole === "admin");
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userRole");
    setIsAuthenticated(false);
    setIsAdmin(false);
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Login route available to everyone */}
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        {/* Forgot password route available to everyone */}
        <Route
          path="/forgot-password"
          element={
            isAuthenticated ? (
              <Navigate to="/" />
            ) : (
              <ForgotPassword />
            )
          }
        />

        {/* Protected routes that require authentication */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                <Home />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/coriander"
          element={
            isAuthenticated ? (
              <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                <Coriander />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/turmeric"
          element={
            isAuthenticated ? (
              <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                <Turmeric />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/packaging"
          element={
            isAuthenticated ? (
              <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                <Packaging />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/rtc"
          element={
            isAuthenticated ? (
              <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                <RTC />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Admin-only route for user management */}
        <Route
          path="/admin/users"
          element={
            isAuthenticated ? (
              isAdmin ? (
                <Layout onLogout={handleLogout} isAdmin={isAdmin}>
                  <UserManagement />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Redirect all other routes to home */}
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;